import React from 'react';
import ReactModal from 'react-modal';
import { ModalStyle, OverlayStyle } from './BaseModal.styles';

const BaseModal = ({
  isOpen,
  children,
  onClose,
  shouldCloseOnOverlayClick = true,
  animationDuration = 300,
  customModalStyles,
  customOverlayStyles,
  desktopMode = 'dialog',
  desktopMaxWidth = '60rem',
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      closeTimeoutMS={animationDuration}
      onRequestClose={onClose}
      className="_"
      overlayClassName="_"
      contentElement={props => (
        <ModalStyle
          {...props}
          style={customModalStyles}
          $animationDuration={animationDuration}
          $desktopMode={desktopMode}
          $desktopMaxWidth={desktopMaxWidth}>
          {children}
        </ModalStyle>
      )}
      overlayElement={(props, contentElement) => (
        <OverlayStyle
          {...props}
          $customStyles={customOverlayStyles}
          $animationDuration={animationDuration}
          $desktopMode={desktopMode}>
          {contentElement}
        </OverlayStyle>
      )}
      shouldCloseOnEsc={shouldCloseOnOverlayClick}
      ariaHideApp={false}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    />
  );
};

export default BaseModal;
